import keyMirror from "ramda-extension/es/keyMirror";
export const actionTypes = keyMirror({
    SAVE_IASC_DATA: null,
    SAVE_IASC_ID: null
});
export const REDUCER_NAME = 'iasc';
export default {
    actionTypes,
    REDUCER_NAME
};
